import { useState } from "react";
import { FaStar } from "react-icons/fa";
import { motion } from "framer-motion";

const ReviewsCard = ({ order, name, text }) => {
  const [show, setShow] = useState(true);

  const handleClick = () => {
    setShow(!show);
  };

  return (
    <motion.div
      initial={
        order == 1
          ? { x: -60, opacity: 0 }
          : order == 3
          ? { x: 60, opacity: 0 }
          : { opacity: 0 }
      }
      whileInView={{ x: 0, opacity: 1 }}
      viewport={{ once: true }}
      transition={{
        duration: 1,
        delay: 0.5,
      }}
      className="bg-[rgba(0,0,0,0.4)] px-[25px] sm:px-[30px] lg:px-[40px] py-[15px] sm:py-[20px] md:py-[25px]"
    >
      <h2 className="text-white text-[20px] mb-[5px]">{name}</h2>
      <div className="flex gap-[5px] text-yellow text-[18px] mb-[15px]">
        <FaStar className="" />
        <FaStar className="" />
        <FaStar className="" />
        <FaStar className="" />
        <FaStar className="" />
      </div>
      <p
        className={`text-white text-[16px] transition-all duration-500 font-extralight ${
          show && "line-clamp-5 lg:line-clamp-none"
        }`}
      >
        {text}
      </p>
      <div
        className="flex lg:hidden items-center justify-center bg-yellow h-[35px] w-[150px] text-[16px] mx-auto my-[15px] font-bold cursor-pointer"
        onClick={handleClick}
      >
        {show ? "Show more" : "Hide"}
      </div>
    </motion.div>
  );
};

export default ReviewsCard;
